// Import warning suppression FIRST, before React
import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "./assets/icons.css";
import App from "./App";
import { Provider } from "react-redux";
import { configureStore } from "./Store";
import { BrowserRouter as Router } from "react-router-dom";
import registerServiceWorker from "./registerServiceWorker";
import configuration from "./configuration";
import ComponentOverride from "./ComponentOverride";
import { Oidc, InMemoryWebStorage } from "@axa-fr/react-oidc-redux";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import * as excelExporter from "devextreme/excel_exporter";
import { ExcelExportDefaultFileName, ExcelExportDefaultSheetName } from "./const/constants";

if (typeof window !== 'undefined') {
  window.ExcelJS = ExcelJS;
  window.saveAs = saveAs;
  window.excelExporter = excelExporter;
  
  // Global Excel export handler for DevExtreme DataGrid
  window.handleDevExtremeDataGridExport = function(e, fileName = ExcelExportDefaultFileName, sheetName = ExcelExportDefaultSheetName) {
    try {
      // Use globally available libraries
      if (!window.ExcelJS || !window.saveAs || !window.excelExporter) {
        console.error('Excel export libraries are not available. Please ensure ExcelJS, file-saver, and devextreme/excel_exporter are loaded globally.');
        e.cancel = true;
        return;
      }
      
      const workbook = new window.ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet(sheetName);
      
      window.excelExporter.exportDataGrid({
        component: e.component,
        worksheet: worksheet,
        autoFilterEnabled: true
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          window.saveAs(new Blob([buffer], { type: 'application/octet-stream' }), fileName);
        });
      }).catch((error) => {
        console.error(error);
      });
      e.cancel = true;
    } catch (error) {
      console.error(error);
      e.cancel = true;
    }
  };
}

const store = configureStore();


const Start = (
  <Provider store={store}>
    <Oidc
      store={store}
      configuration={configuration.config}
      isEnabled={true}
      callbackComponentOverride={ComponentOverride}
      UserStore={InMemoryWebStorage}
    >
      <Router>
        <App />
      </Router>
    </Oidc>
  </Provider>
);

ReactDOM.render(Start, document.getElementById("root"));
registerServiceWorker();
